import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const FaqWrap = styled.div`
  margin: -24.5px 0 148px 0;
  ${customMedia.lessThan('tablet')`
    margin: -18px 0 124px 0;
`}
`
const FaqTab = styled.div`
  display: flex;
  border-bottom: 1px solid ${COLOR.blueGray2};
`
const FaqTabItem = styled.p`
  font-family: NotoSansMedium, sans-serif;
  font-size: 16px;
  line-height: 23px;
  color: ${(props) => props.color};
  border-bottom: ${(props) => props.color === COLOR.black && '1px solid black'};
  margin: 0;
  padding: 8px 8px 9px 8px;
  cursor: pointer;
  ${customMedia.lessThan('tablet')`
    font-size: 14px;
    line-height:20px;
`}
`
const FaqList = styled.div`
  display: block;
  ${customMedia.lessThan('tablet')`
    margin-bottom: 43px;
`}
`
const FaqListItemQ = styled.div`
  height: 78px;
  cursor: pointer;
  line-height: 78px;
  border-bottom: 1px solid ${COLOR.blueGray2};
  font-size: 16px;
  font-family: NotoSansBold, sans-serif;
  padding-left: 20px;
  white-space: pre-line;
  display: flex;
  align-items: center;

  span {
    &:before {
      content: 'Q. ';
      color: ${COLOR.point1};
    }
  }

  ${customMedia.lessThan('tablet')`
     height: auto;
     line-height: 23px;
     padding: 20px 10px;
     span {
       width: 95%;
       display:inline-block;
       vertical-align: center;
     }
   `}
`

const FaqArrow = styled.div<{ active: boolean }>`
  margin: 0 20px 0 auto;
  text-align: right;
  &:after {
    position: absolute;
    content: '';
    width: 8px; /* 사이즈 */
    height: 8px; /* 사이즈 */
    border-top: 1px solid #a7b7ce; /* 선 두께 */
    border-right: 1px solid #a7b7ce; /* 선 두께 */
    transform: ${(props) => (props.active ? 'rotate(-45deg)' : 'rotate(135deg)')};
    transition: transform 500ms;
  }
`

const FaqListItemA = styled.div`
  display: flex;
  font-size: 16px;
  line-height: 23px;
  font-family: NotoSansRegular, sans-serif;
  padding: 22px 20px 26px 21px;
  background: ${COLOR.gray10};
  white-space: pre-line;

  &:before {
    font-family: NotoSansBold, sans-serif;
    content: 'A. ';
    padding: 0 11px 0 0;
    color: ${COLOR.point1};
  }

  ${customMedia.lessThan('tablet')`
    font-size: 14px;
    line-height: 20px;
    padding: 17px 39px 16px 16px;
`}
`
export { FaqArrow, FaqList, FaqListItemA, FaqListItemQ, FaqTab, FaqTabItem, FaqWrap }
